import { clientService } from '../services/clientService';
import { rosterService } from '../services/rosterService';

export const testApiConnection = async () => {
    try {
        
        // Test authentication status
        const token = localStorage.getItem('accessToken');
        const user = localStorage.getItem('user');

        // Test client API
        try {
            const clients = await clientService.getClients();
            return {
                auth: { hasToken: !!token, hasUser: !!user },
                clientApi: { status: 'success', data: clients },
                rosterApi: null
            };
        } catch (clientError: any) {
            
            // Test roster API even if client fails
            try {
                const shifts = await rosterService.getShifts();
                return {
                    auth: { hasToken: !!token, hasUser: !!user },
                    clientApi: { status: 'error', error: clientError.response?.data || clientError.message },
                    rosterApi: { status: 'success', data: shifts }
                };
            } catch (rosterError: any) {
                return {
                    auth: { hasToken: !!token, hasUser: !!user },
                    clientApi: { status: 'error', error: clientError.response?.data || clientError.message },
                    rosterApi: { status: 'error', error: rosterError.response?.data || rosterError.message }
                };
            }
        }
    } catch (error) {
        return {
            auth: { hasToken: false, hasUser: false },
            clientApi: { status: 'error', error: 'Connection failed' },
            rosterApi: { status: 'error', error: 'Connection failed' }
        };
    }
};